// extracted by mini-css-extract-plugin
var _1 = "SupportLauncherButton-moduleactive__GZQ25";
var _2 = "SupportLauncherButton-modulecounter__deF4m";
var _3 = "SupportLauncherButton-modulesupportButton__VJJbU";
var _4 = "SupportLauncherButton-modulewrapper__vSYnJ";
export { _1 as "active", _2 as "counter", _3 as "supportButton", _4 as "wrapper" }
